document.addEventListener("DOMContentLoaded", () => {
	const openButtons = document.querySelectorAll(".open-popup-button");
	const closeButtons = document.querySelectorAll(".close-popup-element");

	openButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			e.preventDefault();
			const popupId = button.dataset.popupId;
			const overlay = document.getElementById(popupId);
			if (overlay) {
				overlay.classList.add("popup-active");
				document.body.classList.add("no-scroll");
			}
		});
	});

	closeButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const overlay = button.closest(".popup-overlay");
			if (overlay) {
				overlay.classList.remove("popup-active");
				document.body.classList.remove("no-scroll");
			}
		});
	});

	document.querySelectorAll(".popup-overlay").forEach((overlay) => {
		overlay.addEventListener("click", (e) => {
			if (e.target === overlay) {
				overlay.classList.remove("popup-active");
				document.body.classList.remove("no-scroll");
			}
		});
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			const activePopup = document.querySelector(".popup-overlay.popup-active");
			if (activePopup) {
				activePopup.classList.remove("popup-active");
				document.body.classList.remove("no-scroll");
			}
		}
	});
});
